import { Card, List } from "antd";
import { useSelector } from "react-redux";

import useSmartNavigate from "hooks/useSmartNavigate";
import { getImage, getCatalogCardWebpUrl } from "helpers";
import { PRODUCTS_GRID } from "constants/breakpoints";

const dataCategories = [
  {
      "name": "Говядина",
      "image": "catalog/cat-cover/cat-goviadina.jpg",
      "path": "govyadina",
  },
  {
      "name": "Баранина",
      "image": "catalog/cat-cover/cat-baranina.jpg",
      "path": "baranina",
  },
  {
      "name": "Птица",
      "image": "catalog/cat-cover/cat-ptica.jpg",
      "path": "ptitsa",
  },
  {
      "name": "Полуфабрикаты (охлажд.)",
      "image": "catalog/cat-cover/cat-polufabricaty.jpg",
      "path": "polufabrikaty-ohlazhd",
  },
  {
      "name": "Полуфабрикаты (заморож.)",
      "image": "catalog/cat-cover/zampolufabr.jpg",
      "path": "polufabrikaty-zamorozh",
  },
  {
      "name": "Колбасные изделия",
      "image": "catalog/cat-cover/cat-kolbasy.jpg",
      "path": "kolbasnye-izdeliya",
  },
  {
      "name": "Деликатесы",
      "image": "catalog/cat-cover/cat-delikatesy.jpg",
      "path": "delikatesy",
  },
  {
      "name": "Маринады",
      "image": "catalog/cat-cover/cat-marinady.jpg",
      "path": "marinady",
  },
  {
      "name": "Корм для животных",
      "image": "catalog/cat-cover/cat-korm.jpg",
      "path": "korm-dlya-zhivotnyh",
  },
  {
      "name": "Сопутствующие товары",
      "image": "catalog/cat-cover/cat-copurstvuyushie.jpg",
      "path": "soputstvuyushtie-tovary",
  },
  {
      "name": "Субпродукты",
      "image": "catalog/cat-cover/cat-subproducty.jpg",
      "path": "subprodukty",
  }
];

const Catalog = ({ breadcrumb, grid }) => {
  const { navigate } = useSmartNavigate();
  const catalogCardThumbs = useSelector((state) => state.layout.mainInfo?.data?.catalog_card_thumbs);

  return (
    <div className="region catalog-section">
      {breadcrumb ? (
        breadcrumb
      ) : (
        <div className="contact-breadcrumb" style={{ marginTop: "64px" }}>
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate("/");
            }}
            className="breadcrumb-link"
          >
            Главная
          </a>
          <span className="breadcrumb-separator breadcrumb-separator-active"></span>
          <span className="breadcrumb-current">Каталог</span>
        </div>
      )}
      <div className="catalog-section-header">
        <h2 className="catalog-title">КАТАЛОГ</h2>
      </div>

      <List
        grid={grid || PRODUCTS_GRID}
        className="catalog-products-list"
        dataSource={dataCategories}
        renderItem={(item) => (
          <List.Item>
            <Card 
              onClick={() => navigate(`/catalog/${item.path}`)}
              className="catalog-card"
              bodyStyle={{ padding: 0, height: '100%', position: 'relative' }}
            >
              <img
                src={catalogCardThumbs?.[item.image] || getCatalogCardWebpUrl(item.image)}
                alt=""
                className="catalog-card-image"
                onError={(e) => {
                  if (e.target.src !== getImage(item.image)) {
                    e.target.src = getImage(item.image);
                  }
                }}
              />
              <div className="catalog-card-title">{item.name}</div>
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};

export default Catalog;
